import classes from './GuestRoomSummary.module.css'

const GuestRoomSummary = (props) => {
  //guestNum
  //roomNum

  return (
    <div className={classes.guestRoomContainer}>
      <div className={`${classes.guestContainer}  ${classes.guestIcon}`}>
        <p className={classes.headerText}>Guests</p>
        <p className={classes.numberText}>{props.guestNum}</p>
      </div>
      <div className={`${classes.roomContainer}  ${classes.roomIcon}`}>
        <p className={classes.headerText}>Rooms</p>
        <p className={classes.numberText}>{props.roomNum}</p>
      </div>
    </div>
  )
}

export default GuestRoomSummary
